import React from "react";
import { Maybe, SanityDynamicForm } from "@graphql-types";
import DynamicFormView from "../formPermitRequester/dynamicFormView";

interface Props {
  data: Maybe<SanityDynamicForm> | undefined;
}

/** Dynamic form – uses shared dynamic form view (sections + form fields). */
function DynamicForm({ data }: Props) {
  if (data == null) return null;
  return <DynamicFormView formData={data} />;
}

export default DynamicForm;
